import Layout from "@/components/feature/Layout";
import SEOMeta, { SchemaOrg } from "@/components/feature/SEOMeta";
import Hero from "./components/Hero";
import Features from "./components/Features";
import CategoryPreview from "./components/CategoryPreview";
import PopularArticles from "./components/PopularArticles";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";

export default function Home() {
  return (
    <Layout>
      <SEOMeta
        title="9170登录手机版入口_官方移动端快速登录指南"
        description="9170登录手机版入口官方指南，提供最新手机版登录地址、快速访问入口及常见问题解决方案。支持iOS与Android设备，一键进入9170手机版，安全稳定，随时随地畅享完整服务体验。"
        keywords="9170登录手机版入口,9170手机版登录,9170移动端入口,9170官方登录,9170手机版地址,9170快速登录,9170最新入口"
        canonicalUrl="/"
        ogUrl="/"
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "9170登录手机版入口_官方移动端快速登录指南",
          description:
            "9170登录手机版入口官方指南，提供最新手机版登录地址、快速访问入口及常见问题解决方案。",
          url: "https://9170.com",
          isPartOf: {
            "@type": "WebSite",
            name: "9170登录手机版入口",
            url: "https://9170.com",
          },
        }}
      />
      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "9170手机版登录入口在哪里？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "9170官方手机版登录入口请以官方最新公告为准。建议将官方入口地址添加到手机浏览器书签或手机桌面，以确保始终访问正确的地址。",
              },
            },
            {
              "@type": "Question",
              name: "9170手机版支持哪些设备？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "9170手机版全面支持iOS（iPhone/iPad）和Android设备（手机/平板），兼容Safari、Chrome、Edge等主流浏览器，无需下载任何APP，通过浏览器即可直接访问。",
              },
            },
            {
              "@type": "Question",
              name: "9170手机版安全吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "9170手机版采用HTTPS加密传输、多重安全防护机制，确保您的数据安全。建议用户开启双重认证、使用强密码、不在公共Wi-Fi下进行敏感操作。",
              },
            },
            {
              "@type": "Question",
              name: "9170手机版需要下载APP吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "不需要！9170手机版是基于浏览器的Web应用，您只需使用手机浏览器访问官方入口即可使用全部功能。可以将入口添加到手机主屏幕，像原生应用一样运行。",
              },
            },
          ],
        }}
      />
      <Hero />
      <Features />
      <CategoryPreview />
      <PopularArticles />
      <FAQ />
      <CTA />
    </Layout>
  );
}